import { render, staticRenderFns } from "./stopsTable.vue?vue&type=template&id=56fa6c42&"
import script from "./stopsTable.vue?vue&type=script&lang=js&"
export * from "./stopsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports